import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { button, text } from './styles.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';
import { Box } from '../Box/Box.web.js';
import { handleButtonUnfocusMouseEvent } from './utils.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';
import { useComponentVariant } from '../utils/hooks/useComponentVariant.js';

/**
 * Buttons make common actions visible and easy to perform. Some examples
 * include Submit, Save, Log in.
 */
var Button = function Button(props) {
  var color = props.color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$invert = props.invert,
      invert = _props$invert === void 0 ? false : _props$invert,
      _props$status = props.status,
      status = _props$status === void 0 ? 'primary' : _props$status,
      _props$size = props.size,
      size = _props$size === void 0 ? 'm' : _props$size,
      children = props.children,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      onMouseUp = props.onMouseUp,
      onMouseOut = props.onMouseOut,
      tag = props.tag,
      textColor = props.textColor,
      variantProp = props.variant,
      rest = _objectWithoutProperties(props, ["color", "disabled", "invert", "status", "size", "children", "leftIcon", "rightIcon", "onMouseUp", "onMouseOut", "tag", "textColor", "variant"]);

  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var rawTheme = theme.button.web;
  var buttonTheme = useComponentVariant(rawTheme, variant);
  var handleMouseUp = React.useCallback(handleButtonUnfocusMouseEvent(onMouseUp), [onMouseUp]);
  var handleMouseOut = React.useCallback(handleButtonUnfocusMouseEvent(onMouseOut), [onMouseOut]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(button, _extends({
    "data-test": "elemental-Button",
    type: "button" // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    as: tag,
    withLeftIcon: Boolean(leftIcon),
    withRightIcon: Boolean(rightIcon),
    onMouseUp: handleMouseUp,
    onMouseOut: handleMouseOut,
    color: color ? color : buttonTheme.color,
    disabled: disabled === true,
    "aria-disabled": Boolean(disabled) ? true : undefined,
    disabledStyle: disabled === 'style-only',
    disabledColor: theme.button.web.disabledColor,
    invert: invert,
    status: status,
    size: size,
    textColorProp: textColor,
    variant: variant
  }, rest), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    height: "100%"
  }, leftIcon && renderComponentOrElement(leftIcon, {
    size: 24
  }), children && /*#__PURE__*/React.createElement(text, null, children), rightIcon && renderComponentOrElement(rightIcon, {
    size: 24
  }))));
};

export { Button };
